import React, { useEffect, useRef, useState } from "react";

/**
 * Reveal: wraps children with a scroll-triggered fade/slide animation
 * Variants: up | left | right | fade | scale
 */
export const Reveal = ({ children, variant = "up", delay = 0, className = "", as: Tag = "div" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const base = "transition-all duration-700 ease-out will-change-transform";
  const hidden = {
    up: "opacity-0 translate-y-8",
    left: "opacity-0 -translate-x-8",
    right: "opacity-0 translate-x-8",
    fade: "opacity-0",
    scale: "opacity-0 scale-95"
  }[variant];
  const shown = "opacity-100 translate-x-0 translate-y-0 scale-100";

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`${base} ${visible ? shown : hidden} ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
